import Routes from './routes';
import { ThemeProvider as AppThemeProvider } from './hooks/useAppTheme';

const App = () => {
  return (
    <AppThemeProvider>
      <Routes />
    </AppThemeProvider>
  );
};

export default App;
